module.exports = __webpack_public_path__ + "static/media/YM24_2.f2d3173b.jpg";